// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__88zNl","turquoise":"Button_turquoise__VsawH","purple":"Button_purple__7pgSS","standardWidth":"Button_standardWidth__lpb9s"};